import LoginForm from "./login-form";
import Header from "../Header";
import Footer from "../Footer";

export default function AuthenticationView() {

  return (
    <>
      <Header logoSrc="/images/nhwm_logo.png" variant="cs_heading_color" />
      <div
        className="min-h-[100vh] w-full bg-cover bg-center flex items-center justify-center pb-10"
        style={{ backgroundImage: "url('/images/nhwm/bg_cover.jpg')" }}
      >
        <div className="relative flex flex-col justify-center items-center bg-white/20 backdrop-blur-sm shadow-lg shadow-gray-400 rounded-[20px] p-6 w-[95%] md:max-w-[600px] min-h-[30vh] mt-[150px]  overflow-hidden">
          <div>
            <h3>Log In</h3>
          </div>
          <div className="transition-all duration-500 mt-8 w-full md:w-[70%]">
            <LoginForm />
          </div>
          <div>
            <p className="text-center text-gray-500 mt-4">
              Don't have an account?{" "}
              <a
                href="/register"
                className="text-blue-500 hover:underline"
              >
                Register
              </a>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
